// const data = [{
//   name: '湖南',
//   value: 84
// }, {
//   name: '上海',
//   value: 54
// }, {
//   name: '广东',
//   value: 46
// }, {
//   name: '福建',
//   value: 26
// }, {
//   name: '安徽',
//   value: 26
// }];

const habitPieOpt = (options) => {
  const titleArr = [], 
    seriesArr = [];
  const colors = [['#FE9B37', '#dfeaff'], ['#48DA26', '#ffdcc3'], ['#1C6EFB', '#ffedcc'], ['#F40F5D', '#fed4e0'], ['#98F8FF', '#1C6EFB']];
  options.forEach((item, index) => {
    titleArr.push(
      {
        text: item.name,
        left: `${index * 20 + 8}%`,
        top: '73%',
        textAlign: 'center',
        textStyle: {
          fontWeight: 'normal',
          fontSize: '11',
          // color: colors[index][0],
          color: '#fff',
          textAlign: 'center',
        },
      }        
    );
    seriesArr.push(
      {
        name: item.name,
        type: 'pie',
        clockWise: true,
        radius: [25, 30],
        itemStyle: {
          normal: {
          // borderColor: '#fff',
            color: colors[index][0],
            shadowColor: colors[index][0],
            shadowBlur: 5,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          }
        },
        // emphasis: {
        //   itemStyle: {
        //     borderColor: '#fff'
        //   }
        // },
        hoverAnimation: false,
        center: [`${index * 20 + 10}%`, '40%'],
        data: [{
          value: item.value,
          label: {
            normal: {
              formatter(params) {
                return `${params.value}%`;
              },
              position: 'center',
              show: true,
              textStyle: {
                fontSize: '14',
                fontWeight: 'bold',
                color: colors[index][0]
              }
            }
          },
        }, {
          value: 100 - item.value,
          name: 'invisible',
          itemStyle: {
            normal: {
            // color: colors[index][1]
              color: '#173164'
            },
            emphasis: {
            // color: colors[index][1],  
              color: '#173164'          
            }
          }
        }]
      }    
    );
  });

  return {
    title: titleArr,
    series: seriesArr,
  };
};

export default habitPieOpt;
